import { createContext } from 'react';
import { DEFAULT_THEME_SETTINGS } from './constants';

export const ThemeContext = createContext(DEFAULT_THEME_SETTINGS);
